import { Injectable } from '@angular/core';
import { ObjectTypes } from '../enums/object-types';
import { FieldMapping } from "@common/data-models/service/field-mapping";
import { Record } from '@common/data-models/records/record';
import { CollectionRecord } from "@common/data-models/records/collection-record";
import { GlobalTablesService } from "@common/services/global-tables-service";
import { IFieldMappingService } from "@common/interfaces/i-field-mapping-service";
import { Util } from "@common/utils/util";

@Injectable({ providedIn: 'root' })
export class FieldMappingService implements IFieldMappingService {
    public parentChildDictionary: { [number: string]: number } = {};

    constructor(
        public globalTablesService: GlobalTablesService
    ) {
        this.parentChildDictionary[ObjectTypes.TOPIC] = ObjectTypes.ASSIGNMENT;

        Record.fieldMappingService = this;
    }


    private checkValidationTypes(sourceId: string, destinationId: string): boolean {
        let sourceField = this.globalTablesService.FieldDefsDict[sourceId];
        let destinationField = this.globalTablesService.FieldDefsDict[destinationId];
        let sourceFieldValidation: string = "";
        let destinationFieldValidation: string = "";

        if (sourceField) {
            sourceFieldValidation = sourceField.Validation.toUpperCase();
        }
        if (destinationField) {
            destinationFieldValidation = destinationField.Validation.toUpperCase();
        }
        if (sourceId == "Title" || sourceId == "ENPSText" || sourceId == "ENPSTextBBL") {
            sourceFieldValidation = "TEXT";
        }
        if (destinationId == "Title" || destinationId == "ENPSText" || destinationId == "ENPSTextBBL") {
            destinationFieldValidation = "TEXT";
        }
        return (sourceFieldValidation == destinationFieldValidation);
    }

    private getFieldMappingRules(sourceType: ObjectTypes, destinationType: ObjectTypes): Array<FieldMapping> {
        return this.globalTablesService.FieldMappings.filter((rule: FieldMapping) => {
            return (rule.SourceObjectType == sourceType && rule.DestinationObjectType == destinationType);
        });
    }

    private getCopyToChildRules(sourceType: ObjectTypes, destinationType: ObjectTypes): Array<FieldMapping> {
        return this.getFieldMappingRules(sourceType, destinationType).filter((rule: FieldMapping) => {
            return rule.CopyToChild;
        });
    }

    private getUpdateToChildRules(sourceType: ObjectTypes, destinationType: ObjectTypes): Array<FieldMapping> {
        return this.getFieldMappingRules(sourceType, destinationType).filter((rule: FieldMapping) => {
            return rule.UpdateToChild;
        });
    }

    public updateToChild(parent: CollectionRecord, field: string, value: any) {
        
        let parentType = parent.type;
        let childType = this.parentChildDictionary[parent.type];
        if (parentType && childType) {
            let fieldMappingRules = this.getUpdateToChildRules(parentType, childType).filter((rule: FieldMapping) => {
                return (rule.SourceFieldId == field);
            });
            for (let rule of fieldMappingRules) {
                if (this.checkValidationTypes(rule.SourceFieldId, rule.DestinationFieldId)) {
                    for (let child of parent.children) {
                        let childValue = Util.deepCopy(value);
                        child.set(rule.DestinationFieldId, childValue);
                    }
                }
            }
        }
        
    }

    public copyToChild(parent: CollectionRecord, child: Record) {
        let fieldMappingRules = this.getCopyToChildRules(parent.type, child.type);
        for (let rule of fieldMappingRules) {
            if (this.checkValidationTypes(rule.SourceFieldId, rule.DestinationFieldId)) {
                let value = Util.deepCopy(parent.get(rule.SourceFieldId));
                if (value) {
                    child.set(rule.DestinationFieldId, value);
                }
            }
        }
    }
}
